export default {
  "content": "<path d=\"M13.817 5.119C13.047 2.171 10.509 0 7.5 0 4.49 0 1.953 2.172 1.183 5.119.49 5.413 0 6.13 0 6.974v2c0 1.105.84 2 1.875 2 1.036 0 1.875-.895 1.875-2v-2c0-.62-.269-1.166-.683-1.533C3.683 3.451 5.425 2 7.5 2c2.075 0 3.818 1.451 4.434 3.441a2.04 2.04 0 00-.684 1.533v2c0 .739.38 1.377.938 1.723v1.458l-2.35.501c-.344-.415-.84-.682-1.4-.682-1.036 0-1.875.895-1.875 2s.839 2 1.875 2c.823 0 1.515-.57 1.767-1.357l3.104-.662c.438-.094.754-.504.754-.981v-2.277c.557-.346.937-.984.937-1.723v-2c0-.844-.49-1.561-1.183-1.855z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "15",
    "height": "16",
    "viewBox": "0 0 15 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};